import { Component, OnInit, PipeDecorator, ViewChild } from '@angular/core';
import { ProductService } from '../../shared/services/product.service';
import { ProductDetailModel, ProductModel } from 'src/app/shared/models/product.model';

//import { ToastrService } from 'ngx-toastr';
import { MatTableDataSource, MatSort, MatPaginator} from '@angular/material';
import { MatDialog,MatDialogConfig} from '@angular/material';
import { ProductDetailComponent } from '../product-detail/product-detail.component';
import { GlobalNotification} from "src/app/shared/constants/global-notification";

@Component({
  selector: 'app-product-list',
  templateUrl: './product-list.component.html',
  styleUrls: ['./product-list.component.css']
})
export class ProductListComponent implements OnInit {

  thisData : MatTableDataSource<any>;
  displayColumn : string[]= ['category', 'productName', 'description', 'actions'];
  @ViewChild(MatSort, { static: false }) sort : MatSort;
  @ViewChild(MatPaginator, { static: false }) paginator : MatPaginator;
  searchKey : string;

  dialogConfig = new MatDialogConfig();

  constructor(private service : ProductService,
    //private toastr : ToastrService,
    private gnotify : GlobalNotification,
    private dialog : MatDialog) {


      this.dialogConfig.disableClose = true;
      this.dialogConfig.autoFocus = true;
      this.dialogConfig.width = "50%";
      this.dialogConfig.minWidth="400px";
      this.dialogConfig.maxWidth="600px";
    }

  ngOnInit() {
    this.refreshList();
  }

  onCreate()
  {
    this.service.initializeFormGroup();
    this.dialogConfig.data = {
      result : false
    };

    let dialogRef = this.dialog.open(ProductDetailComponent, this.dialogConfig);
    dialogRef.afterClosed().subscribe(result => {

      if(this.dialogConfig.data.result)
      {
        console.log(true);
        this.refreshList();
      }

    });
  }

  onEdit(row){
    this.service.populateForm(ProductDetailModel.convertToProductModel(row));
    this.dialogConfig.data = {
      result : false
    };

    let dialogRef = this.dialog.open(ProductDetailComponent, this.dialogConfig);
    dialogRef.afterClosed().subscribe(result => {

      if(this.dialogConfig.data.result)
      {
        console.log(true);
        this.refreshList();
      }

    });
  }
  onDelete(id)
  {
    if(!confirm("Are you sure to delete this product?")) return;

    this.service.deleteData(id).subscribe(
      res=>{
        ////this.toastr.warning("Submitted successfully", "Product Delete");
        this.gnotify.showSnackBar('Product Delete', 'Submitted successfully', "warning");
        this.searchKey = "";
        this.refreshList();
      },
      err=>{
        console.log(err);
      }
    );
  }

  refreshList()
  {
    this.service.getList().subscribe(
      res => {
        let array = res as ProductDetailModel[];
        this.thisData = new MatTableDataSource(array);
        this.thisData.sort = this.sort;
        this.thisData.paginator = this.paginator;
        this.applyFilter();
         console.log("refreshList : " + this.thisData.data.length);
         this.applyFilter();
       },
       err =>{
         console.log(err);
       }
    );

  }

  onSearchClear()
  {
    this.searchKey = "";
    this.applyFilter();
  }

  applyFilter()
  {
    if(this.searchKey != null)
      this.thisData.filter = this.searchKey.trim().toLowerCase();
  }

}
